import axios from "axios"
import { logOut } from "../actions/AuthAction";
import store from '../store/ReduxStore';

const API = axios.create({baseURL: process.env.REACT_APP_API_BASE_URL, withCredentials: true});
const api = axios.create({baseURL: process.env.REACT_APP_API_BASE_URL, withCredentials: true});

API.interceptors.response.use(
    response => response, 
    error => {
        if (error.response && error.response.status === 401) {
            console.log("Token expired, logging out user...");

            // Dispatch logout action
            store.dispatch(logOut());
        }
        return Promise.reject(error);
    }
);

export const getCompass = (id) => API.get(`/values/viewcompass/${id}`)
export const createValue = (id, data) => API.put(`/values/create/${id}`, data)
export const getRelations = () => API.get(`/values/relations`)
export const getAllValues = () => api.get(`/values`)
export const updateValue = (userId, pointId, updatedData) => 
    API.patch(`/values/update`, { userId, pointId, ...updatedData });
  
export const deleteValue = (userId, pointId) => 
    API.put(`/values/delete`, { userId, pointId });